import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AppBloc } from '../../bloc/app-bloc';

@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './theme-error-page.component.html',
  styleUrls: ['./theme-error-page.component.scss']
})
export class ThemeErrorPageComponent implements OnInit {

  constructor(private appBloc: AppBloc) { }

  ngOnInit(): void {

  }
}
